export default {
  namespaced: true,
  state: {
    detail: false,
    detailObj: {},
    list: [],
  },
  getters: {
    add: state => state.add,
    detail: state => state.detail,
    detailObj: state => state.detailObj,
    list: state => state.list,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    detailMutate(state, data) {
      state.detail = data;
    },
    detailObjMutate(state, data) {
      state.detailObj = data;
    },
  },
  actions: {
    setList(context, data) {
      context.commit('listMutate', data);
    },
    setDetail(context, data) {
      context.commit('detailMutate', data);
    },
    setDetailObj(context, data) {
      context.commit('detailObjMutate', data);
    },
  },
};
